import { render, staticRenderFns } from "./agent-badge.vue?vue&type=template&id=22d36a68&scoped=true&"
import script from "./agent-badge.vue?vue&type=script&lang=js&"
export * from "./agent-badge.vue?vue&type=script&lang=js&"
import style0 from "./agent-badge.vue?vue&type=style&index=0&id=22d36a68&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d36a68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d36a68')) {
      api.createRecord('22d36a68', component.options)
    } else {
      api.reload('22d36a68', component.options)
    }
    module.hot.accept("./agent-badge.vue?vue&type=template&id=22d36a68&scoped=true&", function () {
      api.rerender('22d36a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/agent-badge/agent-badge.vue"
export default component.exports